interface IngredientInfoTileProps {
  label: string;
  value?: string | number | null;
}

const IngredientInfoTile = ({ label, value }: IngredientInfoTileProps) => {
  return (
    <div className="tw-rounded-lg tw-border tw-border-border tw-bg-secondary/20 tw-px-4 tw-py-3">
      <p className="tw-text-xs tw-text-muted-foreground tw-mb-1">{label}</p>
      <p className="tw-text-sm tw-font-medium tw-text-foreground">
        {value === undefined || value === null || value === "" ? "—" : value}
      </p>
    </div>
  );
};

export default IngredientInfoTile;
